import {
  jb_fullscreen_icon_css_default
} from "./chunk.PFA6B63G.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-fullscreen-icon/jb-fullscreen-icon.ts
var JbFullscreenIcon = class extends Icon(i) {
  render() {
    return b`<div class="fullscreen-icon"></div>`;
  }
};
JbFullscreenIcon.styles = [reset_css_default, jb_fullscreen_icon_css_default];
JbFullscreenIcon = __decorateClass([
  customElement("jb-fullscreen-icon")
], JbFullscreenIcon);

export {
  JbFullscreenIcon
};
